import { InputField, Spinner } from '@welbe/web-design-system';
import { Button, Stack } from '@welbe/design-system';
import { Container } from './SignUp.styles';
import { useSignUp } from './SignUp.hooks';
import React from 'react';

export const SignUp = () => {
	const {
		account,
		confirmationPassword,
		isLoading,
		hasError,
		hasErrorRegex,
		navigate,
		setConfirmationPassword,
		setAccount,
		handleNextField,
		handleSubmit,
	} = useSignUp();

	return (
		<Container id="authentication-form">
			<InputField
				id="email"
				placeholder="Correo de usuario"
				error={hasError && !account.email}
				value={account.email}
				onKeyPress={(event: any) => {
					if (event.key === 'Enter') {
						handleNextField(3);
					}
				}}
				onChange={(value) => setAccount({ ...account, email: value })}
			/>
			<InputField
				id="password"
				className="login-password"
				placeholder="Introducir la contraseña"
				type="password"
				error={
					(hasError && !account.password) ||
					(hasError && confirmationPassword !== account.password)
				}
				errorText={
					hasError && confirmationPassword !== account.password
						? 'Las contraseñas no coinciden'
						: ''
				}
				value={account.password}
				onKeyPress={(event: any) => {
					if (event.key === 'Enter') {
						handleNextField(4);
					}
				}}
				onChange={(value) => setAccount({ ...account, password: value })}
			/>
			<InputField
				id="confirmPassword"
				className="login-password"
				placeholder="Confirma tu contraseña"
				type="password"
				error={(hasError && !account.password) || hasErrorRegex}
				errorText={
					hasErrorRegex
						? `* La contraseña debe tener al menos 8 caracteres, una letra mayúscula, una minúscula, un número y un caracter especial. Caracteres disponibles ^ $ * . [ ] { } ( ) ? " ! @ # % & / ${'\\ ,'} > < ${"'"} ${': ;'} | _ ~ ${'`'} = + - `
						: ''
				}
				value={confirmationPassword}
				onKeyPress={(event: any) => {
					if (event.key === 'Enter') {
						handleNextField(5);
					}
				}}
				onChange={(value) => setConfirmationPassword(value)}
			/>
			<Stack mt="1rem">
				<Button
					id="submit-button"
					disabled={isLoading}
					onClick={handleSubmit}
					width="100%"
				>
					{isLoading ? <Spinner size="24px" color="#fff" /> : 'Enviar'}
				</Button>
				<Button
					variant="ghost"
					onClick={() => navigate('/login')}
					color="#707070"
				>
					Ir a la pantalla de autenticación
				</Button>
			</Stack>
		</Container>
	);
};
